import { Grid } from '@mui/material';
import { getYearMonthDay } from '@nx-smartmonkey/shared/helpers';
import { RoutalTooltip } from '@nx-smartmonkey/ui';
import { render } from 'react-dom';
import { wmoCodeToIconSrc } from '../../../../constants/WeatherCodes';
import { WeatherForecast } from '../../../../domain/weather/WeatherForecast';

const weatherComponent = (weather: WeatherForecast) => (
  <Grid className="sx__month-grid-day__header-weather-icon">
    <RoutalTooltip
      title={
        <Grid container direction="row">
          <span>{`${weather.minTemp}º`}</span>
          <span>/</span>
          <span>{`${weather.maxTemp}º`}</span>
        </Grid>
      }
    >
      <img src={wmoCodeToIconSrc(weather.weatherCode)} alt="weather_element" />
    </RoutalTooltip>
  </Grid>
);

export const addWeatherToDate = (weather: WeatherForecast) => {
  const date = getYearMonthDay({ date: weather.date });

  const containers = document.querySelectorAll<HTMLElement>(`[data-date='${date}']`);

  if (!containers.length) return;

  const headerContainer = containers[0].getElementsByClassName(`sx__month-grid-day__header`);

  if (!headerContainer.length) return;

  const targetHeaderContainer = headerContainer[0] as HTMLElement;

  const weatherContainer = Object.assign(document.createElement(`div`), {
    className: `sx__month-grid-day__header-weather`,
  });

  // Temporary commented. A tooltip should be placed over the weather icon
  // // Add the weather min/max temperature
  // const temperatureElement = Object.assign(document.createElement(`span`), {
  //   className: `sx__month-grid-day__header-weather-temperature`,
  //   innerText: `${weather.minTemp}°/${weather.maxTemp}°`,
  // });
  // weatherContainer.appendChild(temperatureElement);

  targetHeaderContainer.appendChild(weatherContainer);

  render(weatherComponent(weather), weatherContainer);
};
